import { NotificationFragment } from "@graphql/notifications/Notifications.g";
import { Link } from "react-router";
import { Box } from "@design-system/Box/Box";
import { Text } from "@design-system/Text/Text";
import { routes } from "@pages/routes";
import { CompanyCell } from "@design-system/Table/UI/CompanyCell/CompanyCell";
import { UserCell } from "@design-system/Table/UI/UserCell/UserCell";

type Props = {
  notification: NotificationFragment;
};

export const SaasDiscoveredDetails = ({ notification }: Props) => {
  const application = notification.application;
  const client = notification.client;
  const mainApp = application?.resourceGroupApplications?.primaryApplication || application;

  return (
    <Box direction="column" gap={16}>
      <Box direction="column" gap={4}>
        <Text size={12} color="textSecondary" weight={600} uppercase>Client</Text>
        {client ? (
          <Link to={routes.portal.clients.client.dashboard.$buildPath({ params: { clientId: client.id } })} style={{ textDecoration: "none" }}>
            <CompanyCell name={client.name} skipLogo />
          </Link>
        ) : (
          <Text size={14}>—</Text>
        )}
      </Box>

      <Box direction="column" gap={4}>
        <Text size={12} color="textSecondary" weight={600} uppercase>Application</Text>
        {client && application ? (
          <Link to={routes.portal.clients.client.applications.application.dashboard.$buildPath({ params: { clientId: client.id, applicationId: application.id } })} style={{ textDecoration: "none" }}>
            <CompanyCell
              name={mainApp?.resource.productName || "Unknown Application"}
              signedLogoUrl={mainApp?.resource.publicResource?.signedLogoUrl || undefined}
            />
          </Link>
        ) : (
          <Text size={14}>—</Text>
        )}
      </Box>
      
      {notification.employee && (
        <Box direction="column" gap={4}>
          <Text size={12} color="textSecondary" weight={600} uppercase>Related user</Text>
          <Link to={routes.portal.clients.client.clientEmployees.clientEmployee.dashboard.$buildPath({ params: { clientId: client?.id || "", clientEmployeeId: notification.employee.id } })} style={{ textDecoration: "none" }}>
            <UserCell name={notification.employee.name} />
          </Link>
        </Box>
      )}
    </Box>
  );
};
